<template>
  <div id="project">
    <div class="slider-box">
        <el-carousel height="648px">
            <el-carousel-item>
              <img src="../../../static/images/slider-2.png" alt="">
              <ul class="tactic-box">
                <li class="item">
                  <!-- <el-tooltip class="item" effect="dark" content="Top Left 提示文字提示文字提示文字提示文字提示文字提示文字提示文字提示文字提示文字提示文字提示文字" placement="right"> -->
                    <img src="../../../static/images/bank-icon-1.png">
                  <!-- </el-tooltip> -->
                </li>
                <li class="item">
                  <!-- <el-tooltip class="item" effect="dark" content="Right Top 提示文字" placement="left"> -->
                    <img src="../../../static/images/bank-icon-2.png">
                  <!-- </el-tooltip> -->
                </li>
                <li class="item">
                  <!-- <el-tooltip class="item" effect="dark" content="Right Top 提示文字" placement="right"> -->
                    <img src="../../../static/images/bank-icon-3.png">
                  <!-- </el-tooltip> -->
                </li>
                <li class="item">
                  <!-- <el-tooltip class="item" effect="dark" content="Right Top 提示文字" placement="left"> -->
                    <img src="../../../static/images/bank-icon-4.png">
                  <!-- </el-tooltip> -->
                </li>
                <li class="item">
                  <!-- <el-tooltip class="item" effect="dark" content="Right Top 提示文字" placement="right"> -->
                    <img src="../../../static/images/bank-icon-5.png">
                  <!-- </el-tooltip> -->
                </li>
                <li class="item">
                  <!-- <el-tooltip class="item" effect="dark" content="Right Top 提示文字" placement="left"> -->
                    <img src="../../../static/images/bank-icon-6.png">
                  <!-- </el-tooltip> -->
                </li>
                <li class="item">
                  <!-- <el-tooltip class="item" effect="dark" content="Right Top 提示文字" placement="right"> -->
                    <img src="../../../static/images/bank-icon-7.png">
                  <!-- </el-tooltip> -->
                </li>
                <li class="item">
                  <!-- <el-tooltip class="item" effect="dark" content="Right Top 提示文字" placement="left"> -->
                    <img src="../../../static/images/bank-icon-8.png">
                  <!-- </el-tooltip> -->
                </li>
              </ul>
            </el-carousel-item>
            <el-carousel-item>
              <img src="../../../static/images/slider-3.jpeg" alt="">
            </el-carousel-item>
            <el-carousel-item>
              <img src="../../../static/images/slider-4.jpeg" alt="">
            </el-carousel-item>
        </el-carousel>
    </div>
    <div class="plate-box">
      <ul class="plate">
        <li>
          <div class="title">
            <i class="icon1"></i>
            <i class="icon2"></i>
            <span>合作伙伴</span>
            <i class="icon3"></i>
            <i class="icon4"></i>
          </div>
          <div class="list clearfix">
            <span v-for="item of partner.banks" v-text="item.name"></span>
          </div>
        </li>
        <li>
          <div class="title">
            <i class="icon1"></i>
            <i class="icon2"></i>
            <span>申请代理</span>
            <i class="icon3"></i>
            <i class="icon4"></i>
          </div>
          <div class="desc">扫描二维码申请成为代理,赚佣金</div>
          <div class="inner">
            <img src="../../../static/images/qr-code.png" width="87" height="87" alt="">
          </div>
        </li>
        <li>
          <div class="title">
            <i class="icon1"></i>
            <i class="icon2"></i>
            <span>最新动态</span>
            <i class="icon3"></i>
            <i class="icon4"></i>
          </div>
          <div class="desc">了解最新资讯</div>
          <div class="inner">
            <img src="../../../static/images/qr-code.png" width="87" height="87" alt="">
          </div>
        </li>
      </ul>
      <div class="common-tag">金融产品</div>
    </div>
    <div class="banks-box">
      <div class="top">
        <div class="title">信用卡办理</div>
        <div class="news-box">
          <ul :class="{anim:animate==true}">
            <li v-for="(news,index) of cardNews"><span v-text="news.date"></span>&nbsp;恭喜<span v-text="news.phone"></span>办理了<span v-text="news.channel_name"></span>信用卡</li>
          </ul>
        </div>
        <div class="more">更多</div>
      </div>
      <div class="content clearfix">
        <div class="list fleft" v-for="bank of partner.banks">
          <div class="bank-img"><img :src="bank.bank_img" :alt="bank.desc"></div>
          <div class="bank-name" v-text="bank.name"></div>
          <div class="bank-link"><a :href="bank.url">立即办理</a></div>
        </div>
      </div>
    </div>
    <div class="loans-box">
      <div class="top">
        <div class="title">小额贷款</div>
        <div class="news-box">
          <ul>
            <li>极速贷款，当天到账，为你量身打造</li>
          </ul>
        </div>
        <div class="more">更多</div>
      </div>
      <div class="content clearfix">
        <div class="fleft loan-lsit">
          <ul>
            <li v-for="(loan,index) in partner.loans">
              <div class="loan-logo">
                <img :src="loan.logo_img" alt="">
              </div>
              <div class="loan-adv">
                <div class="name" v-text="loan.name"></div>
                <div class="person">适合人群: <span v-text="loan.for_the_crowd"></span></div>
                <div class="day"><span v-text="loan.dealing_time_info"></span></div>
                <div class="desc" v-text="loan.mortgage_info"></div>
              </div>
              <div class="loan-intro">
                <div class="adv-list">
                  <span v-for="(adv,index) in loan.advantage" v-text="adv" :key="index"></span>
                </div>
                <div class="money">放款金额: <span v-text="loan.loan_money"></span>万元</div>
                <div class="money">贷款利率: <span v-text="loan.loan_interest"></span></div>
                <div class="date">贷款期限: <span v-text="loan.loan_time_limit"></span>个月</div>
              </div>
              <div class="loan-qr">
                <img :src="loan.qr_img" alt="">
              </div>
            </li>
          </ul>
        </div>
        <div class="fright adv-box">
          <div class="title">四大优势</div>
          <ul>
            <li>
              <div class="name"><span>多</span>高额度</div>
              <div class="desc">针对个人定制方案，放款更多！</div>
            </li>
            <li>
              <div class="name"><span>快</span>放款快速</div>
              <div class="desc">高效率服务，放款快！</div>
            </li>
            <li>
              <div class="name"><span>好</span>门槛低</div>
              <div class="desc">姿势问题，征信问题，都有解决办法。</div>
            </li>
            <li>
              <div class="name"><span>省</span>利率低</div>
              <div class="desc">渠道多，选择更广</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
      <!-- <div class="clearfix project-box">
          <div class="business-box">
              <div class="business-item">
                  <h3 class="title">免费办卡</h3>
                  <div class="desc"><span>额度高</span><span>手续简</span><span>下卡快</span></div>
                  <div class="bottom">快速申请</div>
                  <div class="icon">
                    <i class="el-icon-back"></i>
                  </div>
              </div>
          </div>
          <div class="carousel-box">
                <el-carousel trigger="click" height="165px" indicator-position="none" :autoplay="false">
                    <el-carousel-item v-for="(banks,index) of banks">
                        <div class="list clearfix">
                            <a class="item" :class="'item-' + index" :href="bank.url" v-for="(bank,index) of banks">
                                <span><img :src="bank.logo_img"/></span>
                                <h3 class="name" v-text="bank.name"></h3>
                                <div class="desc" v-text="bank.desc"></div>
                                <div class="code-box">
                                  <img :src="bank.qr_img" alt="">
                                </div>
                            </a>
                        </div>
                    </el-carousel-item>
                </el-carousel>
          </div>
      </div> -->
      <!-- <div class="clearfix project-box">
          <div class="business-box loans-box">
              <div class="business-item">
                  <h3 class="title">在线贷款</h3>
                  <div class="desc"><span>额度高</span><span>放款快</span><span>利率低</span></div>
                  <div class="bottom">快速申请</div>
                  <div class="icon">
                    <i class="el-icon-back"></i>
                  </div>
              </div>
          </div>
          <div class="carousel-box">
                <el-carousel trigger="click" height="165px" indicator-position="none" :autoplay="false">
                    <el-carousel-item v-for="(loans,index) of loans">
                        <div class="list clearfix">
                            <a class="item" :class="'item-' + index" :href="loan.url" v-for="(loan,index) of loans">
                                <span><img :src="loan.logo_img"/></span>
                                <h3 class="name" v-text="loan.name"></h3>
                                <div class="desc" v-text="loan.desc"></div>
                                <div class="code-box">
                                  <img :src="loan.qr_img" alt="">
                                </div>
                            </a>
                        </div>
                    </el-carousel-item>
                </el-carousel>
          </div>
      </div> -->
      <div class="core">
        <img src="../../../static/images/core.png" width="966" height="502" alt="">
      </div>
      <div class="img-box"><img src="../../../static/images/banner1.png" alt=""></div>
      <!-- <div class="notice-title">
        <div class="common-tag">信息资讯</div>
      </div> -->
  </div>
</template>
<script>
import Vue from "Vue";

export default {
  name: "Project",
  data() {
    return {
      partner: {},
      advs: [],
      animate: false,
      cardNews: []
    };
  },
  created() {
    this.getCardNews();
    setInterval(this.showMarquee, 3000);
    this.$nextTick(() => {
      this.getPartner();
    })
  },
  methods: {
    getPartner() {
      let params = new URLSearchParams();
      let _this = this;
      _this
        .$http({
          //获取金融产品列表
          method: "get",
          url: _this.$api + "/service/agent/partner/list"
        })
        .then(function(res) {
          _this.partner = res.data.data;
          _this.partner.loans.forEach(element => {
              if (element.advantage.indexOf(",") >= 0) {
                element.advantage = element.advantage.split(",");
              } else {
                element.advantage = element.advantage.split("，");
              }
              console.log(_this.partner.loans);
          });
        });
    },
    getCardNews() {
      let _this = this;
      _this
        .$http({
          method: "get",
          url: _this.$api + "/sys/new_card_info"
        })
        .then(res => {
          if (res.data.code == 200) {
            _this.cardNews = res.data.data;
          }
        });
    },
    showMarquee() {
      this.animate = true;
      setTimeout(() => {
        this.cardNews.push(this.cardNews[0]);
        this.cardNews.shift();
        this.animate = false;
      }, 500);
    }
  },
  components: {}
};
</script>
<style lang="stylus" scoped>
.slider-box {
  position: relative;
  width: 1336px;
  margin: 0 auto;

  &:before {
    position: absolute;
    display: block;
    content: '';
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: transparent;
    z-index: 28;
  }

  img {
    width: 100%;
  }
}

.tactic-box {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;

  img {
    width: 169px;
    height: 62px;
  }

  li {
    position: absolute;
    display: inline-block;
    cursor: pointer;

    &:nth-of-type(1) {
      left: 280px;
      top: 150px;
    }

    &:nth-of-type(2) {
      right: 280px;
      top: 150px;
    }

    &:nth-of-type(3) {
      left: 220px;
      top: 240px;
    }

    &:nth-of-type(4) {
      right: 200px;
      top: 240px;
    }

    &:nth-of-type(5) {
      left: 280px;
      top: 330px;
    }

    &:nth-of-type(6) {
      right: 238px;
      top: 330px;
    }

    &:nth-of-type(7) {
      left: 220px;
      top: 424px;
    }

    &:nth-of-type(8) {
      right: 212px;
      top: 424px;
    }
  }
}

.common-tag {
  position: absolute;
  width: 140px;
  height: 60px;
  line-height: 60px;
  background: #123e97;
  color: #fff;
  text-align: center;

  &:before {
    position: absolute;
    display: inline-block;
    content: '';
    width: 6px;
    height: 6px;
    top: 50%;
    margin-top: -3px;
    left: 20px;
    background: #fff;
    border-radius: 50%;
  }
}

.plate-box {
  position: relative;
  width: 100%;
  height: 366px;

  .common-tag {
    left: 137px;
    bottom: 55px;
  }

  .plate {
    position: absolute;
    width: 100%;
    top: -35px;
    text-align: center;
    z-index: 10;

    li {
      display: inline-block;
      width: 286px;
      height: 195px;
      background: #fff;
      margin-right: 38px;
      box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
      overflow: hidden;
    }

    li:last-child {
      margin-right: 0;
    }

    .title {
      position: relative;
      height: 32px;
      line-height: 32px;
      margin-top: 24px;
      font-size: 18px;

      i {
        position: absolute;
        width: 60px;
        height: 1px;
        background: #dadada;
      }

      i.icon1 {
        left: 26px;
        top: 12px;
      }

      i.icon2 {
        top: 12px;
        right: 26px;
      }

      i.icon3 {
        top: 20px;
        left: 20px;
      }

      i.icon4 {
        top: 20px;
        right: 20px;
      }
    }

    .desc {
      font-size: 12px;
      color: #999;
    }

    .list {
      width: 240px;
      margin: 12px auto 0 auto;
      text-align: left;

      span {
        display: inline-block;
        padding: 5px 8px;
        font-size: 16px;
        color: #282828;
      }
    }

    .inner {
      text-align;
      height: 128px;
      line-height: 128px;

      img {
        vertical-align: middle;
      }
    }
  }
}

.banks-box {
  position: relative;
  padding: 0 20px;

  .top {
    position: relative;
    display: flex;
    width: 100%;
    margin-bottom: 20px;
    border-bottom: 1px solid #123e97;

    .title {
      flex: 0 0 100px;
      width: 100%;
      height: 40px;
      line-height: 40px;
    }

    .news-box {
      flex: 1;
      height: 40px;
      overflow: hidden;

      .anim {
        transition: all 1.5s;
        margin-top: -40px;
      }

      li {
        width: 100%;
        height: 40px;
        line-height: 40px;
        color: #999;

        span {
          color: red;
        }
      }
    }

    .more {
      flex: 0 0 50px;
      height: 40px;
      line-height: 40px;
      color: #123e97;
      cursor: pointer;
    }
  }

  .content {
    text-align: center;
    margin-bottom: 20px;

    .list {
      margin: 10px 12px;
    }

    .bank-img {
      width: 234px;
      height: 147px;
      border-radius: 5px;
      overflow: hidden;

      img {
        display: inline;
        width: 100%;
        height: auto;
      }
    }

    .bank-name {
      width: 100%;
      height: 40px;
      line-height: 40px;
    }

    .bank-link {
      a {
        display: block;
        width: 120px;
        height: 30px;
        line-height: 30px;
        margin: 0 auto;
        background: #123e97;
        color: #fff;
        border-radius: 3px;
      }
    }
  }
}

.loans-box {
  position: relative;
  padding: 0 20px;

  .top {
    position: relative;
    display: flex;
    width: 100%;
    margin-bottom: 20px;
    border-bottom: 1px solid #123e97;

    .title {
      flex: 0 0 80px;
      width: 100%;
      height: 40px;
      line-height: 40px;
    }

    .news-box {
      flex: 1;
      height: 40px;
      overflow: hidden;

      li {
        width: 100%;
        height: 40px;
        line-height: 40px;
        color: #999;

        span {
          color: red;
        }
      }
    }

    .more {
      flex: 0 0 50px;
      height: 40px;
      line-height: 40px;
      color: #123e97;
      cursor: pointer;
    }
  }

  .content {
    position: relative;
    width: 96%;
    margin: 0 auto;

    .loan-lsit {
      width: 870px;

      ul {
        border-left: 1px solid #d6d6d6;
        border-right: 1px solid #d6d6d6;

        li {
          display: flex;
          width: 100%;
          height: 150px;
          border-top: 1px solid #d6d6d6;
          color: #9a9a9a;

          &:last-child {
            border-bottom: 1px solid #d6d6d6;
          }

          .loan-logo {
            flex: 0 0 144px;
            line-height: 150px;
            text-align: center;

            img {
              display: inline-block;
              width: 100px;
              height: 100px;
              vertical-align: middle;
            }
          }

          .loan-adv {
            flex: 0 0 154px;
            line-height: 2;

            .name {
              color: #6d6d6d;
              font-size: 18px;
              margin-top: 15px;
            }
          }

          .loan-intro {
            flex: 1;
            line-height: 2;

            .adv-list {
              margin-top: 15px;
              margin-bottom: 5px;
              font-size: 14px;

              span {
                display: inline-block;
                padding: 0 5px;
                margin-right: 5px;
                border: 1px solid red;
                color: red;
              }
            }
          }

          .loan-qr {
            flex: 0 0 200px;
            line-height: 150px;
            text-align: center;

            img {
              display: inline-block;
              width: 100px;
              height: 100px;
              vertical-align: middle;
            }
          }
        }
      }
    }

    .adv-box {
      width: 300px;
      border-left: 1px solid #d6d6d6;
      border-right: 1px solid #d6d6d6;
      overflow: hidden;

      .title {
        width: 100%;
        height: 40px;
        line-height: 40px;
        padding-left: 15px;
        background: #efefef;
        color: #666;
      }

      li {
        width: 100%;
        height: 150px;
        text-align: center;
        border-bottom: 1px solid #d6d6d6;
        overflow: hidden;

        .name {
          margin-top: 40px;
          color: #666;

          span {
            display: inline-block;
            color: #77c1de;
            padding: 10px;
            border: 2px solid #77c1de;
            border-radius: 50%;
            margin-right: 5px;
            font-size: 18px;
            margin-bottom: 5px;
          }
        }
      }
    }
  }
}

.project-box {
  font-szie: 0;
  padding: 20px 0;
  margin-bottom: 15px;
  background: #f1f1f1;

  .business-box {
    float: left;
    width: 234px;
    height: 165px;
    background: #f1eded;
    text-align: center;
    margin-right: 14px;
    border-top: 1px solid #e53935;

    .title {
      color: #ef3a3b;
      font-size: 21px;
      padding-top: 15px;
    }

    .desc {
      color: #ebb111;
      font-size: 13px;
      margin: 15px auto;

      span {
        margin: 0 5px;
      }
    }

    .icon {
      margin-top: 20px;
      font-size: 30px;
      transform: rotate(180deg);
      color: #e53935;
      animation: forwards 0.5s linear infinite alternate;
    }

    @keyframes forwards {
      0% {
        transform: translateX(10px) rotate(180deg);
      }

      100% {
        transform: translateX(0) rotate(180deg);
      }
    }
  }

  .carousel-box {
    float: right;
    width: 1088px;
    height: 165px;
    overflow: hidden;

    .list {
      font-size: 0;

      .item {
        position: relative;
        display: block;
        float: left;
        width: 234px;
        height: 165px;
        background: #fff;
        margin-right: 14px;
        font-size: 12px;
        text-align: center;
        overflow: hidden;
        transition: all 0.2s linear;
        cursor: pointer;

        &:hover .code-box {
          top: 0;
        }

        .code-box {
          position: absolute;
          width: 100%;
          height: 100%;
          background: #fff;
          top: 100%;
          left: 0;
          right: 0;
          bottom: 0;
          transition: all 0.35s;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
          }
        }

        span {
          display: block;
          width: 60px;
          height: 60px;
          margin: 18px auto;
          padding: 5px 0;

          img {
            width: 100%;
          }
        }

        .name {
          color: #000;
          font-size: 14px;
          font-weight: 400;
          margin: 0 10px 7px;
        }

        .desc {
          height: 18px;
          font-size: 12px;
          margin: 0 10px 10px;
          white-space: nowrap;
          text-overflow: ellipsis;
          color: #b0b0b0;
          overflow: hidden;
        }

        .now {
          margin: 0 10px 14px;
          color: #ff6700;
        }
      }

      .item-0 {
        border-top: 1px solid #ffac13;
      }

      .item-1 {
        border-top: 1px solid #83c44e;
      }

      .item-2 {
        border-top: 1px solid #2196f3;
      }

      .item-3 {
        border-top: 1px solid #e53935;
        margin-right: 0;
      }
    }
  }
}

.img-box {
  margin: 0 auto;
  text-align: center;
}

.core {
  position: relative;
  width: 100%;
  height: 757px;
  line-height: 757px;
  text-align: center;

  img {
    vertical-align: middle;
  }
}

.notice-title {
  position: relative;
  width: 100%;
  height: 200px;
  border-top: 10px solid #e8e8e8;

  .common-tag {
    left: 137px;
    bottom: 55px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/project/project.vue